import { string, object } from 'yup';

export const assignPersonValidationSchema = object().shape({
    type: string().required('Type is required'),
    person_id: string().required('Person is required'),
    person_position_id: string().required('Position is required'),
});
